export enum NgFormStatusEnum {
    VALID = 'VALID',
    INVALID = 'INVALID',
}
